<template>
  <div>
    <v-simple-table dense class="bordered--table">
      <template v-slot:default>
        <thead>
          <tr>
            <th class="text-left" v-for="(head, index) in headers" :key="index">{{ head.text }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(data, index) in monthsUsageRecords" :key="index">
            <td>{{ data.productnumber }}</td>
            <td>{{ data.productdescription }}</td>
            <td>{{ data.productgroupname }}</td>
            <td>{{ data.mainsuppliername }}</td>
            <td>
              <v-icon v-if="data.stockitem">mdi-check</v-icon>
              <v-icon v-else>mdi-close</v-icon>
            </td>
            <td>{{ data.salesunit }}</td>
            <td>{{ data.orderunit }}</td>
            <td class="text-right">{{ data.packageqty | replaceDotWithComma }}</td>
            <td class="text-right">{{ data.minimumqty | replaceDotWithComma }}</td>
            <td class="text-right">{{ data.orderqty | replaceDotWithComma }}</td>
            <td class="text-right">{{ data.available | replaceDotWithComma }}</td>
            <td class="text-right">{{ data.monthsusage | replaceDotWithComma }}</td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
  </div>
</template>
<script>
export default {
  props: ['monthsUsageRecords'],
  computed: {
    headers () {
      return [{
        text: this.$t('message.reports.prodNo')
      }, {
        text: this.$t('message.customer.description')
      }, {
        text: this.$t('message.customer.productGroup')
      }, {
        text: this.$t('message.reports.vendor')
      }, {
        text: this.$t('message.product.isStockItem')
      }, {
        text: this.$t('message.product.salesUnit')
      }, {
        text: this.$t('message.product.orderUnit')
      }, {
        text: this.$t('message.product.packageQty')
      }, {
        text: this.$t('message.product.minQty')
      }, {
        text: this.$t('message.product.orderQty')
      }, {
        text: this.$t('message.product.available')
      }, {
        text: this.$t('message.product.monthUsage')
      }]
    }
  }
}
</script>
